import { IGetFolhaPagamentoDetalhadaDropDownUseCase } from "../../../presentation/useCases/read/get_folha_pagamento_detalhada_drop_down_use_case";
import { FolhaPagamentoDropDown } from "../../models/folha_pagamento_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFolhaPagamentoDetalhadaDropDownUseCase
 */

export class GetFolhaPagamentoDetalhadaDropDownUseCase implements IGetFolhaPagamentoDetalhadaDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFolhaPagamentoDetalhadaDropDown(): Promise<FolhaPagamentoDropDown[]> {
    return await this.repository.getFolhaPagamentoDetalhadaDropDown();
  }
}
